export default __webpack_public_path__ + "static/media/TERMSANDCONDITIONS_ko.75556da1.docx";